module.exports = __webpack_public_path__ + "static/media/main.d9cc1425.jpg";